import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./ScrollNav.css";

const ScrollNav = ({ categories, pageTitle }) => {
  const [activeCategory, setActiveCategory] = useState("");
  const navCategoriesRef = useRef(null);
  const navigate = useNavigate();

  // Scroll navbar to active category
  const scrollNavToCategory = (categoryId) => {
    const navContainer = navCategoriesRef.current;
    const activeButton = navContainer?.querySelector(
      `[data-category="${categoryId}"]`
    );

    if (navContainer && activeButton) {
      const containerWidth = navContainer.offsetWidth;
      const buttonLeft = activeButton.offsetLeft;
      const buttonWidth = activeButton.offsetWidth;

      // Calculate center position
      const scrollPosition = buttonLeft - containerWidth / 2 + buttonWidth / 2;

      navContainer.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = categories.map((category) =>
        document.getElementById(category.id)
      );

      let current = "";
      sections.forEach((section) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            current = section.id;
          }
        }
      });

      if (current !== activeCategory) {
        setActiveCategory(current);
        scrollNavToCategory(current);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener("scroll", handleScroll);
  }, [categories, activeCategory]);

  const scrollToSection = (categoryId) => {
    const element = document.getElementById(categoryId);
    if (element) {
      const offsetTop = element.offsetTop - 120; // Account for nav height
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  const goHome = () => {
    navigate("/");
  };

  return (
    <nav className="scroll-nav">
      <div className="scroll-nav-content">
        <button className="back-button" onClick={goHome}>
          ← Назад
        </button>

        <h1 className="page-title">{pageTitle}</h1>

        <div className="nav-categories" ref={navCategoriesRef}>
          {categories.map((category) => (
            <button
              key={category.id}
              data-category={category.id}
              className={`nav-category ${
                activeCategory === category.id ? "active" : ""
              }`}
              onClick={() => scrollToSection(category.id)}
            >
              {category.title}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default ScrollNav;
